<script>
	import '../../app.css';
	import { page } from '$app/stores';
	const PROD_URL = 'https://davidoff-immo.up.railway.app';

	let scroll;
	let speed = 3;
	let windowY = 0;

	/** @type {import('./$types').PageData} */
	export let data;

	const bg = data.bg.data.attributes.Bild.data[0].attributes.url;
	const wertermittlung = data.wertermittlung.data[0].attributes;
	const immobilienkauf = data.immobilienkauf.data[0].attributes;
	const marketing = data.marketing.data[0].attributes;
	const aftersales = data.aftersales.data[0].attributes;
	const immobilienverkauf = data.immobilienverkauf.data[0].attributes;
</script>

<svelte:head>
	<title>Leistungen</title>
	<meta
		name="description"
		content="Ich fertige für Sie ein Immobilienwertgutachten und eine Marktwertermittlung an. Außerdem unterstütze ich Sie beim Immobilienkauf und -verkauf, sowie beim Makrketing und den Aftersales."
	/>
</svelte:head>
<svelte:window bind:scrollY={scroll} bind:innerHeight={windowY} />

<section class="relative w-full h-full">
	<div
		style:Height={windowY / 2 + 'px'}
		style="background-image:url({bg}); background-size:cover; background-position:center; background-repeat:no-repeat;"
		class="parallel-parallax w-full h-full overflow-hidden flex flex-row"
	>
		<!--2 container die in entgegengesetzte Richtung laufen-->
		<div
			style:transform={`translate3d(0, ${scroll * speed}px, 0)`}
			class="parallax-container w-full relaitve h-full flex justify-center items-start"
		/>
		<div
			style:transform={`translate3d(0, ${scroll * -speed}px, 0)`}
			class="relative w-full h-full"
		/>
	</div>
	<div class="relative flex flex-col justify-center items-center leistungen w-full h-full bg-white">
		<div class="werte">
			<h2 class="text-5xl py-8">Wertermittlung</h2>
			<hr />
			<div class="werteBox">
				<div class="w-2/5 h-1/2">
					<h3>
						{wertermittlung.HeadingOne}
					</h3>
					<div class="imgBox">
						<img
							src={wertermittlung.PictureTwo.data.attributes.url}
							alt={wertermittlung.PictureTwo.data.attributes.alternativeText}
						/>
					</div>
					<p class="pt-8">{wertermittlung.TextOne}</p>
				</div>
				<div class="relative w-2/5 h-1/2">
					<h3>
						{wertermittlung.HeadingTwo}
					</h3>
					<div class="imgBox">
						<img
							src={wertermittlung.PictureOne.data.attributes.url}
							alt={wertermittlung.PictureOne.data.attributes.alternativeText}
						/>
					</div>
					<p class="pt-8">{wertermittlung.TextTwo}</p>
				</div>
			</div>
		</div>
		<div class="Immobilienkauf">
			<h2 class="text-5xl py-8">{immobilienkauf.Heading}</h2>
			<hr />
			<div class="immoBox">
				<div class=" w-2/5 h-1/2">
					<div class="imgBox">
						<img
							class=""
							src={immobilienkauf.Picture.data.attributes.url}
							alt={immobilienkauf.Picture.data.attributes.alternativeText}
						/>
					</div>
				</div>
				<div class="relative w-2/5 h-1/2">
					<p>{immobilienkauf.Text}</p>
				</div>
			</div>
		</div>
		<div class="Immobilienverkauf">
			<h2 class="text-5xl py-8">{immobilienverkauf.Heading}</h2>
			<hr />
			<div class="immoBox">
				<div class=" w-2/5 h-1/2">
					<div class="imgBox">
						<img
							class=""
							src={immobilienverkauf.Picture.data.attributes.url}
							alt={immobilienverkauf.Picture.data.attributes.alternativeText}
						/>
					</div>
				</div>
				<div class="relative w-2/5 h-1/2">
					<p>{immobilienverkauf.Text}</p>
				</div>
			</div>
		</div>
		<div class="marketing">
			<h2 class="text-5xl py-8">Marketing</h2>
			<hr />
			<div class="marketingBox">
				<div class=" w-2/5 h-1/2">
					<div class="imgBox">
						<img
							class=""
							src={marketing.Bild.data.attributes.url}
							alt={marketing.Bild.data.attributes.alternativeText}
						/>
					</div>
				</div>
				<div class="relative w-2/5 h-1/2">
					{#each marketing.BulletList as marketing}
						<ul>
							<li>{marketing.BulletHeading}</li>
						</ul>
						<p>{marketing.Description}</p>
					{/each}
				</div>
			</div>
		</div>
		<div class="aftersales">
			<h2 class="text-5xl py-8">After Sales</h2>
			<hr />
			<div class="aftersalesBox">
				<div class=" w-2/5 h-1/2">
					<div class="imgBox">
						<img
							class=""
							src={aftersales.Bild.data.attributes.url}
							alt={aftersales.Bild.data.attributes.alternativeText}
						/>
					</div>
				</div>
				<div class="relative w-2/5 h-1/2">
					<p>{aftersales.Beschreibung}</p>
				</div>
			</div>
		</div>
	</div>
</section>

<style>
	:root {
		--primary-color: #aa9173;
	}
	h2 {
		width: 100%;
		font-size: 3rem;
		color: var(--primary-color);
		text-transform: uppercase;
		white-space: wrap;
	}
	h3 {
		white-space: wrap;
		text-transform: uppercase;
		font-size: 2rem;
		padding: 2rem 0;
	}
	.werte {
		margin: 5rem 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 90%;
	}
	.werteBox {
		margin: 2rem 0;
		display: flex;
		width: 100%;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
	}
	.werteBox > div {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		height: 800px;
	}
	.Immobilienkauf,
	.Immobilienverkauf {
		margin: 2rem 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 90%;
	}
	.immoBox {
		margin: 2rem 0;
		display: flex;
		flex-direction: row;
		width: 100%;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
	}
	.marketing {
		margin: 2rem 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 90%;
	}
	.marketingBox {
		margin: 2rem 0;
		display: flex;
		flex-direction: row;
		width: 100%;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
	}
	.aftersales {
		margin: 2rem 0;
		display: flex;
		flex-direction: row;
		width: 90%;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
	}
	.aftersalesBox {
		margin: 2rem 0;
		display: flex;
		flex-direction: row;
		width: 100%;
		flex-wrap: wrap;
		align-items: flex-start;
		justify-content: space-between;
	}
	li {
		font-size: 1.5rem;
		padding: 1rem 0;
		font-weight: 400;
		hyphens: auto;
		white-space: wrap;
		list-style-position: outside;
		list-style-type: disc;
	}

	hr {
		width: 100%;
		border: 2px solid var(--primary-color);
	}
	p {
		white-space: wrap;
		text-align: justify;
		font-size: 1.5rem;
		line-height: 2.5rem;
		hyphens: auto;
		flex-grow: 1;
	}

	.imgBox {
		max-height: 300px;

		width: 100%;
		object-fit: cover;
		overflow: hidden;
		box-shadow: 3px 3px 10px var(--primary-color);
	}
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
		object-position: center;
	}
	@media only screen and (max-width: 1000px) {
		li {
			font-size: 1.2rem;
			padding: 1rem 0;
			font-weight: 400;
			hyphens: auto;
			white-space: wrap;
			list-style-position: outside;
			list-style-type: disc;
		}
		h2 {
			width: 100%;
			font-size: 2rem;
			color: var(--primary-color);
			text-transform: uppercase;
			white-space: wrap;
		}
		h3 {
			white-space: wrap;
			text-transform: uppercase;
			font-size: 1.5rem;
			padding: 2rem 0;
		}
		p {
			white-space: wrap;
			text-align: justify;
			font-size: 1rem;
			line-height: 1.8rem;
			hyphens: auto;
			flex-grow: 1;
		}
	}

	@media only screen and (max-width: 600px) {
		h2 {
			width: 100%;
			font-size: 1.8rem;
			color: var(--primary-color);
			text-transform: uppercase;
			white-space: wrap;
			padding: 1rem 0;
		}
		h3 {
			white-space: wrap;
			text-transform: uppercase;
			font-size: 1.5rem;
			padding: 2rem 0;
		}
		p {
			white-space: wrap;
			text-align: justify;
			font-size: 1.2rem;
			line-height: 1.8rem;
			hyphens: auto;
		}
		.werte {
			height: auto;
			margin-bottom: 0;
		}
		.werteBox {
			display: flex;
			width: 100%;
			height: auto;
			flex-wrap: wrap;
			align-items: center;
			justify-content: space-between;
			flex-direction: column;
		}
		.werteBox div {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: auto;
			justify-content: space-between;
			align-items: flex-start;
			margin: 1rem 0;
		}
		.immoBox {
			margin: 1rem 0;
			display: flex;
			flex-direction: column;
			width: 100%;
			flex-wrap: wrap;
			align-items: center;
			justify-content: space-between;
		}
		.immoBox > div {
			width: 100%;
			padding: 1rem 0;
		}
		.marketingBox {
			margin: 2rem 0;
			display: flex;
			flex-direction: column;
			width: 100%;
			flex-wrap: wrap;
			align-items: center;
			justify-content: space-between;
		}
		.marketingBox > div {
			width: 100%;
			padding: 1rem 0;
		}
		.aftersalesBox {
			margin: 2rem 0;
			display: flex;
			flex-direction: column;
			width: 100%;
			flex-wrap: wrap;
			align-items: center;
			justify-content: space-between;
		}
		.aftersalesBox > div {
			width: 100%;
			padding: 1rem 0;
		}

		li {
			font-size: 1.5rem;
			padding: 1rem 0;
			font-weight: 200;
			hyphens: auto;
			color: var(--primary-color);
			white-space: wrap;
			font-style: italic;
			list-style-type: none;
		}
	}
</style>
